import { render, staticRenderFns } from "./AllWelcome.vue?vue&type=template&id=3c18ca7a&scoped=true"
import script from "./AllWelcome.vue?vue&type=script&lang=ts"
export * from "./AllWelcome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c18ca7a",
  null
  
)

export default component.exports